import { VITE_ENV } from './constants.js'

const isProduction = VITE_ENV === 'production'

export const debug = {
  error: (message: string) => !isProduction && console.error(message),
  log: (message: string) => !isProduction && console.info(message),
}
